module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_20.17d96e6f.pdf";